export const LOCAL_BUILD_VERSION = 'dev';

export const BUILD_VERSION: string = __BUILD_VERSION__;

export const isLocalBuild = BUILD_VERSION === LOCAL_BUILD_VERSION;
